import { useMutation } from "@tanstack/react-query";
import { Button, Image, Modal, Table } from "@mantine/core";
import { notifications } from "@mantine/notifications";
import { UserMinus } from "lucide-react";
import React, { useState } from "react";
import { axiosInstance } from "../../utils/api";

const RemoveCast = ({ reload, record, type, id }) => {
  const [open, setOpen] = useState(false);
  const cast = record.cast;
  const { mutate, isPending } = useMutation({
    mutationFn: async (castId) => {
      const { data } = await axiosInstance.put(`/admin/remove-${type}-cast`, {
        castId,
        [type === "series" ? "seriesId" : "movieId"]: id,
      });
      return data;
    },
    onSuccess: () => {
      reload();
      notifications.show({ message: "Cast removed successfully", color: "green" });
      setOpen(false);
    },
  });

  return (
    <>
      <span
        onClick={() => setOpen(true)}
        style={{
          display: "flex",
          alignItems: "center",
          gap: "8px",
          color: "#ff4d4f",
          cursor: "pointer",
        }}
      >
        <UserMinus size={16} />
        Remove Cast
      </span>
      <Modal opened={open} onClose={() => setOpen(false)} title="Remove Cast" size="lg">
        <Table>
          <Table.Thead>
            <Table.Tr>
              <Table.Th>Image</Table.Th>
              <Table.Th>Name</Table.Th>
              <Table.Th>Role</Table.Th>
              <Table.Th>Action</Table.Th>
            </Table.Tr>
          </Table.Thead>
          <Table.Tbody>
            {(cast || []).map((item) => (
              <Table.Tr key={item._id}>
                <Table.Td>
                  <Image src={item.image} alt={item.name} w={60} />
                </Table.Td>
                <Table.Td>{item.name}</Table.Td>
                <Table.Td>{item.role}</Table.Td>
                <Table.Td>
                  <Button
                    color="red"
                    onClick={() => mutate(item._id)}
                    loading={isPending}
                    size="xs"
                  >
                    Remove
                  </Button>
                </Table.Td>
              </Table.Tr>
            ))}
          </Table.Tbody>
        </Table>
      </Modal>
    </>
  );
};

export default RemoveCast;
